import { useAccountContext } from 'src/components/account/context'

import MaybeCashback from './MaybeCashback'

type CashbackStripeProps = {
  cashbackStipeMainText: string
  cashbackStipeSecondText: string
  enableSession: boolean
  linkURL: string
  linkText: string
}

export default function CashbackStripe({
  cashbackStipeMainText,
  cashbackStipeSecondText,
  enableSession,
  linkURL,
  linkText,
}: Readonly<CashbackStripeProps>) {
  const { isLoggedIn } = useAccountContext()

  if (!enableSession) {
    return null
  }

  return !isLoggedIn ? (
    <MaybeCashback
      cashbackStipeMainText={cashbackStipeMainText}
      cashbackStipeSecondText={cashbackStipeSecondText}
      linkURL={linkURL}
      linkText={linkText}
    />
  ) : null
}
